import $ from 'jquery'
import { runStaggerReveal } from '../animations'
import initHomepageCards from '../moneySendCard'

runStaggerReveal({ container: '.how_monixa_works', card: '.how_monixa_works__card' })

$(() => {
    initHomepageCards() // MoneySent cards homepage
})
